import { BrowserRouter, Routes, Route } from "react-router";
import Home from "./components/Home";
import ChatPage from "./pages/ChatPage";
import TestVoicePage from "./pages/TestVoicePage";
//changes here
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chat/:assistantId" element={<ChatPage />} />
        <Route path="/testt" element={<TestVoicePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
